import useParseEquation from '../hooks/useParseEquation'
import { EquationSign, OperatorSignType } from '../types'

import {
  Addition,
  Digit,
  Division,
  Power,
  SquareRoot,
  Subtraction,
  Multiplication,
  ParenthesisEquation,
} from './Operators'

interface EquationProps {
  statement: string
  onOperatorClick?: (indexInEquation: number, type: OperatorSignType) => void
  addWithIndex?: number
  isWrong?: boolean
}

const Equation = ({
  statement,
  onOperatorClick,
  addWithIndex = 0,
  isWrong = false,
}: EquationProps): React.ReactElement => {
  const parsedEquation = useParseEquation(statement)

  const renderEquation = ({ type, value, indexInEquation: index, equation }: EquationSign): React.ReactElement => {
    const indexInEquation = index + addWithIndex

    switch (type) {
      case OperatorSignType.ADDITION:
        return (
          <Addition
            isWrong={isWrong}
            key={indexInEquation}
            onClick={onOperatorClick ? () => onOperatorClick(indexInEquation, type) : undefined}
          />
        )
      case OperatorSignType.SUBTRACTION:
        return (
          <Subtraction
            isWrong={isWrong}
            key={indexInEquation}
            onClick={onOperatorClick ? () => onOperatorClick(indexInEquation, type) : undefined}
          />
        )
      case OperatorSignType.MULTIPLICATION:
        return (
          <Multiplication
            isWrong={isWrong}
            key={indexInEquation}
            onClick={onOperatorClick ? () => onOperatorClick(indexInEquation, type) : undefined}
          />
        )
      case OperatorSignType.DIVISION:
        return (
          <Division
            isWrong={isWrong}
            key={indexInEquation}
            onClick={onOperatorClick ? () => onOperatorClick(indexInEquation, type) : undefined}
          />
        )
      case OperatorSignType.POWER:
        return (
          <Power
            isWrong={isWrong}
            key={indexInEquation}
            onClick={onOperatorClick ? () => onOperatorClick(indexInEquation - 1, type) : undefined}
            value={value || ''}
          />
        )
      case OperatorSignType.SQUARE_ROOT:
        return (
          <SquareRoot
            eq={equation || ''}
            indexInEquation={indexInEquation}
            isWrong={isWrong}
            key={indexInEquation}
            onClick={onOperatorClick ? () => onOperatorClick(indexInEquation, type) : undefined}
            onEqOperatorClick={onOperatorClick}
          />
        )
      case OperatorSignType.DIGIT:
        return <Digit key={indexInEquation} value={value || ''} />
      case OperatorSignType.PARENTHESIS_EQUATION:
        return (
          <ParenthesisEquation
            eq={equation || ''}
            indexInEquation={indexInEquation}
            isWrong={isWrong}
            key={indexInEquation}
            onEqOperatorClick={onOperatorClick}
          />
        )
    }
  }

  return <div className="flex items-center justify-center flex-wrap">{parsedEquation.map(renderEquation)}</div>
}

export default Equation
